import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

function O2TableHeaderCell(props) {
  var children = props.children,
      className = props.className,
      sort = props.sort,
      activeSort = props.activeSort,
      link = props.link,
      onClick = props.onClick,
      href = props.href,
      attributes = _objectWithoutPropertiesLoose(props, ["children", "className", "sort", "activeSort", "link", "onClick", "href"]);

  var onClickWrapper = function onClickWrapper(e) {
    e.preventDefault();

    if (props.disabled) {
      return;
    }

    if (onClick) {
      onClick(e);
    }
  };

  if (link) {
    var linkClasses = classNames({
      'o2-table__order-link': sort,
      'o2-table__order-link--active': sort && activeSort,
      'o2-table__order-link--asc': sort && activeSort === 'asc'
    });
    return /*#__PURE__*/React.createElement("th", _extends({}, attributes, {
      className: className
    }), /*#__PURE__*/React.createElement("a", {
      href: href || '#',
      className: linkClasses,
      onClick: onClickWrapper
    }, children));
  }

  var classes = classNames(className, {
    'o2-table__order-cell': sort,
    'o2-table__order-cell--active': sort && activeSort,
    'o2-table__order-cell--asc': sort && activeSort === 'asc'
  });
  return /*#__PURE__*/React.createElement("th", _extends({}, attributes, {
    className: classes,
    onClick: onClickWrapper
  }), children);
}

O2TableHeaderCell.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  link: PropTypes.bool,
  sort: PropTypes.bool,
  activeSort: PropTypes.oneOf(['asc', 'desc'])
};
export default O2TableHeaderCell;